import * as messageService from "../../services/message.service";
import * as businessUsePercentageService from '../../services/businessUsePercentage.service';


const state = {
    businessUsePercentageAll:[],
    businessUsePercentageAllActive:[],
};

const getters = {
    gettBusinessUsePercentageAll:state => (state.businessUsePercentageAll),
    gettBusinessUsePercentageAllActive:state => (state.businessUsePercentageAllActive),
};

const actions = {
    async fetchBusinessUsePercentageAll({ commit } ){
        try {
            const response = await businessUsePercentageService.all();
            commit('setBusinessUsePercentageAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchBusinessUsePercentageAllActive({ commit } ){
        try {
            const response = await businessUsePercentageService.allActive();
            commit('setBusinessUsePercentageAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setBusinessUsePercentageAll:(state, res) => (
        state.businessUsePercentageAll =  res
    ),
    setBusinessUsePercentageAllActive:(state, res) => (
        state.businessUsePercentageAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}